import { createFileRoute, redirect } from '@tanstack/react-router'

// The standalone courses index duplicated Learn's Courses tab with a stale
// layout; consolidated in the 2026-06 IA cleanup (TD-016). Course detail
// pages (/courses/$courseId) are unaffected.
export const Route = createFileRoute('/_auth/courses/')({
  beforeLoad: () => {
    throw redirect({ to: '/learn', search: { tab: 'Courses', tour: undefined, invitationcode: undefined, __clerk_ticket: undefined }, replace: true })
  },
})
